var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// libs/integration-layer/src/lib/application/context.ts
import { ApplicationContext } from "@one-inch-community/core/application-context";
var GlobalApplicationContext;
async function bootstrapApplicationContext() {
  GlobalApplicationContext = new ApplicationContext({
    connectWalletControllerFactory: () => import("@one-inch-community/sdk/wallet").then((m) => m.createConnectWalletController()),
    tokenControllerFactory: () => import("@one-inch-community/sdk/tokens").then((m) => new m.TokenController()),
    notificationsControllerFactory: () => import("@one-inch-community/widgets/notifications").then((m) => new m.NotificationsController()),
    i18nControllerFactory: () => import("@one-inch-community/core/lit").then((m) => new m.I18nController()),
    themesControllerFactory: () => import("@one-inch-community/core/theme").then((m) => new m.ThemeController()),
    storageControllerFactory: () => import("@one-inch-community/core/storage").then((m) => m.storage),
    tokenRateProviderFactory: () => import("@one-inch-community/sdk/tokens").then((m) => m.buildDefaultTokenRateProvider()),
    oneInchDevPortalAdapterFactory: () => import("@one-inch-community/sdk/api").then((m) => new m.OneInchDevPortalAdapter()),
    swapContextFactory: (context) => import("@one-inch-community/sdk/swap").then((m) => {
      const swapContext = new m.SwapContext(context);
      swapContext.init();
      return swapContext;
    })
  });
  await GlobalApplicationContext.init();
}
function getContext() {
  if (!GlobalApplicationContext) throw new Error("ApplicationContext not bootstrapped");
  return GlobalApplicationContext;
}

// libs/integration-layer/src/lib/application/bootstrap.ts
import { html as html2, render } from "lit";

// libs/integration-layer/src/lib/application/global-application-context.element.ts
import { customElement } from "lit/decorators.js";
import { css, html, LitElement } from "lit";

// node_modules/.pnpm/@lit+context@1.1.3/node_modules/@lit/context/lib/context-request-event.js
var s = class extends Event {
  constructor(s4, t2, e3) {
    super("context-request", { bubbles: true, composed: true }), this.context = s4, this.callback = t2, this.subscribe = e3 ?? false;
  }
};

// node_modules/.pnpm/@lit+context@1.1.3/node_modules/@lit/context/lib/value-notifier.js
var s2 = class {
  get value() {
    return this.o;
  }
  set value(s4) {
    this.setValue(s4);
  }
  setValue(s4, t2 = false) {
    const i2 = t2 || !Object.is(s4, this.o);
    this.o = s4, i2 && this.updateObservers();
  }
  constructor(s4) {
    this.subscriptions = /* @__PURE__ */ new Map(), this.updateObservers = () => {
      for (const [s5, { disposer: t2 }] of this.subscriptions) s5(this.o, t2);
    }, void 0 !== s4 && (this.value = s4);
  }
  addCallback(s4, t2, i2) {
    if (!i2) return void s4(this.value);
    this.subscriptions.has(s4) || this.subscriptions.set(s4, { disposer: () => {
      this.subscriptions.delete(s4);
    }, consumerHost: t2 });
    const { disposer: h } = this.subscriptions.get(s4);
    s4(this.value, h);
  }
  clearCallbacks() {
    this.subscriptions.clear();
  }
};

// node_modules/.pnpm/@lit+context@1.1.3/node_modules/@lit/context/lib/controllers/context-provider.js
var e = class extends Event {
  constructor(t2) {
    super("context-provider", { bubbles: true, composed: true }), this.context = t2;
  }
};
var i = class extends s2 {
  constructor(s4, e3, i2) {
    super(void 0 !== e3.context ? e3.initialValue : i2), this.onContextRequest = (t2) => {
      const s5 = t2.composedPath()[0];
      t2.context === this.context && s5 !== this.host && (t2.stopPropagation(), this.addCallback(t2.callback, s5, t2.subscribe));
    }, this.onProviderRequest = (s5) => {
      const e4 = s5.composedPath()[0];
      if (s5.context !== this.context || e4 === this.host) return;
      const i3 = /* @__PURE__ */ new Set();
      for (const [s6, { consumerHost: e5 }] of this.subscriptions) i3.has(s6) || (i3.add(s6), e5.dispatchEvent(new s(this.context, s6, true)));
      s5.stopPropagation();
    }, this.host = s4, void 0 !== e3.context ? this.context = e3.context : this.context = e3, this.attachListeners(), this.host.addController?.(this);
  }
  attachListeners() {
    this.host.addEventListener("context-request", this.onContextRequest), this.host.addEventListener("context-provider", this.onProviderRequest);
  }
  hostConnected() {
    this.host.dispatchEvent(new e(this.context));
  }
};

// node_modules/.pnpm/@lit+context@1.1.3/node_modules/@lit/context/lib/decorators/provide.js
function e2({ context: e3 }) {
  return (n2, r) => {
    const i2 = /* @__PURE__ */ new WeakMap();
    if ("object" == typeof r) return r.addInitializer(function() {
      i2.set(this, new i(this, { context: e3 }));
    }), { get() {
      return n2.get.call(this);
    }, set(t2) {
      return i2.get(this)?.setValue(t2), n2.set.call(this, t2);
    }, init(t2) {
      return i2.get(this)?.setValue(t2), t2;
    } };
    {
      n2.constructor.addInitializer((n3) => {
        i2.set(n3, new i(n3, { context: e3 }));
      });
      const o = Object.getOwnPropertyDescriptor(n2, r);
      let s4;
      if (void 0 === o) {
        const t2 = /* @__PURE__ */ new WeakMap();
        s4 = { get() {
          return t2.get(this);
        }, set(e4) {
          i2.get(this).setValue(e4), t2.set(this, e4);
        }, configurable: true, enumerable: true };
      } else {
        const t2 = o.set;
        s4 = { ...o, set(e4) {
          i2.get(this).setValue(e4), t2?.call(this, e4);
        } };
      }
      return void Object.defineProperty(n2, r, s4);
    }
  };
}

// libs/integration-layer/src/lib/application/global-application-context.element.ts
import { ApplicationContextToken } from "@one-inch-community/core/application-context";
var GlobalApplicationContextElement = class extends LitElement {
  constructor() {
    super(...arguments);
    this.context = getContext();
  }
  render() {
    return html`<slot></slot>`;
  }
};
GlobalApplicationContextElement.tagName = "global-application-context";
GlobalApplicationContextElement.styles = css`
    :host {
        display: flex;
        flex-direction: column;
        height: 100%;
    }
  `;
__decorateClass([
  e2({ context: ApplicationContextToken })
], GlobalApplicationContextElement.prototype, "context", 2);
GlobalApplicationContextElement = __decorateClass([
  customElement(GlobalApplicationContextElement.tagName)
], GlobalApplicationContextElement);

// libs/integration-layer/src/lib/application/bootstrap.ts
async function bootstrapApplication(entryPointFactory) {
  await Promise.all([
    entryPointFactory(),
    bootstrapApplicationContext()
  ]);
  const template = html2`
    <global-application-context>
      <app-root id="app-root"></app-root>
      <div id="overlay-container"></div>
    </global-application-context>
  `;
  render(template, document.body);
}
export {
  bootstrapApplication
};
//# sourceMappingURL=index.esm.js.map
